import React from 'react'

interface ArrowIconProps {
	fall?: boolean
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ fall = false }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="10"
		fill="none"
		viewBox="0 0 17 10"
		style={{ transform: fall ? 'matrix(1, 0, 0, -1, 0, 0)' : '' }}
	>
		<path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M15.667 1L9.333 7.333 6 4 1 9" />
		<path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M11.664 1h4v4" />
	</svg>
)

export default ArrowIcon
